
















import "lazysizes";
import { Component, Vue } from "vue-property-decorator";
import IAvatar from "../typings/IAvatar";

/**
 * Displays either the captured webcam photo or selected avatar.
 */
@Component
export default class Complete extends Vue {
  /**
   * The base app URI configured in env.
   */
  private get apiUri(): string | undefined {
    return process.env.VUE_APP_API_URI;
  }

  /**
   * The selected avatar.
   */
  private get avatar(): IAvatar | undefined {
    return this.$store.getters.avatar;
  }
}
